<page-toolbar [title]="title"></page-toolbar>

<page-content>
  <mat-card appearance="outlined">
    <form (ngSubmit)="submit()">
      <mat-form-field>
        <mat-label>URL</mat-label>
        <input [(ngModel)]="url" matInput name="url" required>
      </mat-form-field>
      <div class="row">
        <button color="primary" mat-raised-button type="submit">Generate</button>
      </div>
      <div class="result-container">
        <mat-form-field>
          <input [value]="shortUrl" id="shorturl" matInput type="text">
        </mat-form-field>
        <button (click)="copyInputMessage()" mat-icon-button matTooltip="Copy to clipboard" matTooltipPosition="left">
          <mat-icon>file_copy</mat-icon>
        </button>
      </div>
    </form>
  </mat-card>
</page-content>
